<!-- company-invoices-bottom-sheet.component.html -->
<div class="bottom-sheet-container">
  <!-- Header -->
  <div class="bottom-sheet-header">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h4 class="mb-0">Fatture - {{ data.companyName }}</h4>
      <button mat-icon-button (click)="closeSheet()" class="custom-button-border">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container text-center py-4">
    <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
    <p class="mt-2">Caricamento fatture...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="errorMessage && !isLoading" class="error-container text-center py-4">
    <mat-icon color="warn" class="mb-2">error_outline</mat-icon>
    <p>{{ errorMessage }}</p>
    <button matButton="filled" class="izy-button-primary custom-button-border" (click)="loadInvoices()">
      Riprova
    </button>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && !errorMessage && invoices.length === 0" class="empty-state text-center py-4">
    <mat-icon class="mb-2" color="disabled">payments</mat-icon>
    <h5>Nessuna fattura</h5>
    <p class="text-muted">Non ci sono fatture per questo cliente</p>
    <button matButton="filled" class="izy-button-primary custom-button-border" (click)="navigateToNewInvoice()">
      <mat-icon>add</mat-icon>
      Crea Fattura
    </button>
  </div>

  <!-- Invoices List -->
  <mat-list *ngIf="!isLoading && invoices.length > 0" class="invoices-list scrollable-list">
    <div class="mb-3">
      <button matButton="filled" class="izy-button-primary custom-button-border w-100" (click)="navigateToNewInvoice()">
        <mat-icon>add</mat-icon>
        Nuova Fattura
      </button>
    </div>

    <mat-list-item 
      *ngFor="let invoice of invoices" 
      (click)="navigateToInvoice(invoice)"
      class="invoice-item"
    >
      <div matListItemIcon>
        <mat-icon [color]="getStatusColor(invoice)">receipt</mat-icon>
      </div>
      
      <!-- <div matListItemTitle class="d-flex justify-content-between align-items-start">
        <span class="invoice-name">{{ invoice.invoice_name }}</span>
        
      </div> -->
      
      <div matListItemLine class="invoice-line-alt">
        <span class="invoice-date">{{ formatDate(invoice.emission_date) }}</span>
        
        <div class="invoice-meta-group">
          <span class="invoice-amount bold">{{ formatCurrency(invoice.amount) }}</span>
          <mat-chip [color]="getStatusColor(invoice)" selected class="status-chip">
            {{ getInvoiceStatus(invoice) }}
          </mat-chip>
          <span class="invoice-progressive">#{{ invoice.progressive_number }}</span>
        </div>
      </div>
      
    </mat-list-item>
  </mat-list>
</div>
